
import { defineComponent, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { NuxeoOrderResponse } from '@/contracts/api/ResponseContracts'
import { NuxeoOrderRequest } from '@/contracts/api/RequestContracts'
import { nuxeoOrderComplete } from '@/composables/nuxeo'

export default defineComponent(
{
    name: 'PayDeclined',
    setup()
    {
        // Load router:
        const router = useRouter()
        const route = useRoute()
        // Use vuex:
        const store = useStore()
        // Get authentication status:
        const isAuthenticated = store.getters['auth/isAuthenticated']
        const authenticatedUser = store.getters['auth/getUser']

        // Display error:
        store.commit('errors/setNuxeoErrors',
        {
            message: 'Payment declined: Declined'
        })
        router.push({ hash: '#error-summary-container' })
        // Return data:
        return {
            isAuthenticated
        }
    }
})
